import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import Preloader from 'src/components/Preloader';
import DropdownMenu from 'src/components/DropdownMenu';
import { CFDICancelMotives } from 'src/utils/constants/cfdi';
import makeInitialState from './initialState';
import validationSchema from './schema';

const StepOne = ({
  data,
  handleNext,
  open,
  resetRef,
  isLoadingInvoiceCancellation,
  onClose
}) => {
  const initialState = useMemo(() => {
    return makeInitialState(data);
  }, [data]);

  const { t } = useTranslation();

  const onNext = useCallback(
    async values => {
      if (
        values.motive === CFDICancelMotives.ISSUED_WITH_ERRORS_WITH_RELATION
      ) {
        handleNext(values);
      } else {
        handleNext(values, { shouldSubmit: true });
      }
    },
    [handleNext]
  );
  if (!open) return null;
  return (
    <DialogContent id="assign-kam-dialog">
      {isLoadingInvoiceCancellation ? (
        <Preloader />
      ) : (
        <Formik
          initialValues={initialState}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={onNext}
        >
          {({
            errors,
            handleSubmit,
            touched,
            values,
            resetForm,
            setFieldValue
          }) => {
            resetRef.current = () => resetForm();
            return (
              <form onSubmit={handleSubmit}>
                <Box />
                <DropdownMenu
                  list={CFDICancelMotives.map(item => ({
                    name: t(`ENUMS.CFDI_CANCEL_MOTIVES.${item.name}`),
                    key: item.key
                  }))}
                  value={values.motive}
                  setValue={value => setFieldValue('motive', value)}
                  label={t('COMMON.CANCEL_MOTIVE')}
                  error={Boolean(touched.motive && errors.motive)}
                  errorText={touched.motive && t(errors.motive)}
                  onChange={value => setFieldValue('motive', value)}
                />
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    margin: '0.5rem auto'
                  }}
                >
                  <Button
                    onClick={onClose}
                    color="primary"
                    variant="outlined"
                    sx={{ minWidth: '45%' }}
                  >
                    {t('COMMON.CANCEL')}
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ minWidth: '45%' }}
                  >
                    {values.motive ===
                    CFDICancelMotives.ISSUED_WITH_ERRORS_WITH_RELATION
                      ? t('COMMON.NEXT')
                      : t('COMMON.ACCEPT')}
                  </Button>
                </Box>
              </form>
            );
          }}
        </Formik>
      )}
    </DialogContent>
  );
};

StepOne.propTypes = {
  data: PropTypes.object.isRequired,
  handleNext: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  resetRef: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoadingInvoiceCancellation: PropTypes.bool.isRequired
};

export default StepOne;
